// extracted by mini-css-extract-plugin
export var bigger = "homepage-module--bigger--ZA6OI";
export var h2 = "homepage-module--h2--PTH24";
export var homepage = "homepage-module--homepage--5vBVU";